import axios from "../../fetch-api/fetch-api";

export function logoutAuth() {
  return axios.post<void>("/user-logout-v3");
}
